import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Persian_Empire.png' ;

function HistoryPagePersiaGo() {
  return (
    <QuizPage
      title="History: Persian Empire"
      subTopic="Persian Empire"
      backgroundImage={historyImage}
      returnPath="/History-Persian-Empire"
    />
  );
}

export default HistoryPagePersiaGo;   


